import { useState } from "react";
import axios from "axios";
import { toast, Toaster } from "sonner";
import { ARTIST } from "../data/portfolio";
import SocialLinks from "../components/SocialLinks";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sending, setSending] = useState(false);

  const onChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Please fill name, email and message.");
      return;
    }
    setSending(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success("Message sent — I'll reply within a few days.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Couldn't send. Try again shortly.");
    } finally {
      setSending(false);
    }
  };

  return (
    <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 md:py-24" data-testid="contact-page">
      <Toaster theme="dark" position="bottom-right"/>
      <div className="grid grid-cols-12 gap-10">
        <div className="col-span-12 lg:col-span-5 reveal">
          <div className="text-xs uppercase tracking-[0.4em] text-[var(--ember)] mb-6">Contact</div>
          <h1 className="font-serif text-5xl md:text-7xl leading-[0.85] text-[var(--paper)] italic">
            Let's make<br/><em className="text-[var(--ember)]">something</em>.
          </h1>
          <p className="mt-8 text-[var(--bone)] text-lg leading-relaxed max-w-md">
            For feature work, art direction, commissions, gallery enquiries or just a slow conversation about
            light — write to me below.
          </p>
          <div className="mt-10 space-y-3">
            <div className="text-xs uppercase tracking-[0.3em] text-[var(--muted)]">Direct</div>
            <a href={`mailto:${ARTIST.email}`} className="font-serif italic text-2xl text-[var(--paper)] link-underline" data-testid="contact-email">
              {ARTIST.email}
            </a>
          </div>
          <div className="mt-8 space-y-3">
            <div className="text-xs uppercase tracking-[0.3em] text-[var(--muted)]">Social</div>
            <SocialLinks/>
          </div>
        </div>

        <form onSubmit={submit} className="col-span-12 lg:col-span-7 reveal space-y-8" style={{ transitionDelay: "150ms" }} data-testid="contact-form">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <label className="text-xs uppercase tracking-[0.3em] text-[var(--muted)]">Your name</label>
              <input name="name" value={form.name} onChange={onChange} data-testid="contact-name" placeholder="Full name"/>
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.3em] text-[var(--muted)]">Email</label>
              <input name="email" type="email" value={form.email} onChange={onChange} data-testid="contact-email-input" placeholder="you@studio.com"/>
            </div>
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.3em] text-[var(--muted)]">Subject</label>
            <input name="subject" value={form.subject} onChange={onChange} data-testid="contact-subject" placeholder="Commission · Project · Other"/>
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.3em] text-[var(--muted)]">Message</label>
            <textarea name="message" value={form.message} onChange={onChange} data-testid="contact-message" placeholder="Tell me about the project, timeline, mood…"/>
          </div>
          <button
            type="submit"
            disabled={sending}
            data-testid="contact-submit"
            className="group inline-flex items-center gap-4 border hairline px-8 py-4 text-xs uppercase tracking-[0.35em] text-[var(--paper)] hover:bg-[var(--ember)] hover:border-[var(--ember)] hover:text-[var(--ink)] transition-all duration-500 disabled:opacity-50"
          >
            <span>{sending ? "Sending…" : "Send Message"}</span>
            <span className="transition-transform group-hover:translate-x-2">→</span>
          </button>
        </form>
      </div>
    </section>
  );
}
